import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, isSubmitting, formValueSelector} from 'redux-form';

import {EmailField} from 'components/Fields';
import FormField from 'components/FormField';
import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';

import {
  selectForgotPasswordErrors,
  selectForgotPasswordSuccess,
  adminForgotPassword
} from 'ducks/auth';

import './styles.css';

const formSubmit = (values, dispatch) => {
  const {email} = values;

  dispatch(adminForgotPassword({email}));
};

class ForgotPasswordForm extends React.Component<any> {
  render() {
    const {errors, handleSubmit, success, submitting, email} = this.props;
    const submitDisabled = submitting || _.isEmpty(email);

    return (
      <form className="ForgotPasswordForm" onSubmit={handleSubmit}>
        {errors && <ErrorBlock>{errors}</ErrorBlock>}
        {!success && (
          <div className="forgottenPasswordText">
            Forgotten your password? Enter your e-mail address below, and we'll
            send you an e-mail allowing you to reset it.
          </div>
        )}
        {success && (
          <div className="forgottenPasswordText success">
            A password reset token has been sent to your email.
          </div>
        )}
        <FormField>
          <Field
            component={EmailField}
            placeholder="Email"
            name="email"
            disabled={submitting || success}
          />
        </FormField>
        <FormField>
          <Button disabled={submitDisabled || success}>
            Reset my password
          </Button>
        </FormField>
      </form>
    );
  }
}

const formSelector = formValueSelector('forgotPassword');

const mapStateToProps = state => {
  return {
    errors: selectForgotPasswordErrors(state),
    success: selectForgotPasswordSuccess(state),
    submitting: isSubmitting('forgotPassword')(state),
    email: formSelector(state, 'email')
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'forgotPassword',
    onSubmit: formSubmit,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(ForgotPasswordForm)
);
